/** Logs only in Vite dev — keeps production main thread and consoles clean. */
export function devLog(...args: unknown[]) {
  if (import.meta.env.DEV) console.log(...args);
}

export function devWarn(...args: unknown[]) {
  if (import.meta.env.DEV) console.warn(...args);
}
